import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import cn from 'classnames';

import Header from 'components/Header';
import Heading from 'components/Heading';
import Footer from 'components/Footer';
import FormGroup from 'components/Form/FormGroup';
import FormGroupLabel from 'components/FormGroupLabel';
import { Button, ButtonLink } from 'components/Button';

import { nextAction } from 'actions/workflow';
import { parseUrlParams } from 'utils/parseUrlParams';

import style from './style.scss';

const CreditOfferConfirmation = ({ history }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const params = parseUrlParams(window.location.search);
    if (!params.applicationId) {
      history.push('/dashboard/borrowers-merchant');
    }
  }, []);

  const handleButtonClick = (e) => {
    e.preventDefault();
    const params = parseUrlParams(window.location.search);
    if (params.applicationId) {
      setIsLoading(true);

      dispatch(nextAction({
        data: {
          returnURL: `${window.location.origin}/dashboard/borrowers-merchant/complete?applicationId=${params.applicationId}`,
        },
        url: `/workflows/application/${params.applicationId}/workflow/dtm/next`,
        success: (response) => {
          setIsLoading(false);
          const routeUrl = response.state && response.state.url;
          history.push(routeUrl);
        },
        fail: () => {
          setIsLoading(false);
        },
      }));
    }
  };

  return (
    <Fragment>
      <Header />
      <section className="grid-container fluid borrowers-apply page-confirm section">
        <div className="grid-container">
          <div className="grid-x grid-margin-x max-limited">
            {
              <Fragment>
                <Heading
                  heading="Select Loan Offer"
                  isCardVisible={false}
                  className="large-offset-2 large-8"
                />
                <div className="cell small-12 large-8 large-offset-2">
                  <FormGroup className="form-group">
                    <FormGroupLabel value="Confirm Amount of Sale" />
                    <div className="grid-x">
                      <div
                        className={cn('card loan-card', style['loan-card'], style.active, style.selected)}
                      >
                        <div className="grid-x">
                          <div className={cn('cell small-12 medium-4 highlight', style.cell, style.highlight)}>
                            <h5>Estimated<br className="show-for-large" /> Monthly Payment</h5>
                            <h3>$174.68</h3>
                            <small className={style.small}>Offer #220190</small>
                            <Button
                              className={cn('button secondary w-100 btn-select-toggle green', style.selectedButton)}
                            >
                              Selected
                            </Button>
                          </div>
                          <div className={cn('cell small-12 medium-8', style.cell)}>
                            <div className="grid-x">
                              <div className="cell small-6">
                                <h5>Amount Financed</h5>
                              </div>
                              <div className="cell small-6">
                                <h5><em>$5,400.00</em></h5>
                              </div>
                            </div>
                            <div className="grid-x">
                              <div className="cell small-6">
                                <h5>Loan Term</h5>
                              </div>
                              <div className="cell small-6">
                                <h5><em>60 Months</em></h5>
                              </div>
                            </div>
                            <div className="grid-x">
                              <div className="cell small-6">
                                <h5>Interest Rate</h5>
                              </div>
                              <div className="cell small-6">
                                <h5><em>26.02%</em></h5>
                              </div>
                            </div>
                            <div className="grid-x">
                              <div className={cn('cell small-12 promo-message', style.promoMessage)}>
                                <p><em>Special Promotion:</em>  No Interest on principal if your loan is paid in full within the first six months</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="cell small-12 medium-12">
                        <div className="grid-x grid-margin-x">
                          <div className="cell small-4 medium-4">
                            <Button
                              className={cn('button large green', style.button, style.buttonWidth)}
                              onClick={handleButtonClick}
                              isLoading={isLoading}
                            >
                              ESIGN NOW
                            </Button>
                          </div>
                          <div className="cell small-4 medium-4 flexViewHorizontal">
                            <ButtonLink
                              className={style.button}
                              onClick={() => {}}
                            >
                              eSign Later
                            </ButtonLink>
                          </div>
                          <div className="cell small-4 medium-4 flexViewHorizontal">
                            <ButtonLink
                              className={style.button}
                              onClick={() => {}}
                            >
                              Email Client
                            </ButtonLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                </div>
              </Fragment>
            }
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

CreditOfferConfirmation.propTypes = {
  history: PropTypes.object.isRequired,
};

export default CreditOfferConfirmation;



// WEBPACK FOOTER //
// ./src/containers/pages/BorrowerMerchantApply/InternalPages/CreditOfferConfirmation/index.js